import { Type } from '@angular/core';
import { DropdownOptionModel } from '../../Forms/models/dropdown-option.model';
import { AbstractFormFieldComponent } from '../../PageBuilder/components/FormField/abstract-form-field.component';
import { FormFieldModel } from '../../PageBuilder/models/form-field.model';
import { ChartMetricsEnum } from '../enums/chart-metrics.enum';

export interface MultiMetricSettings {
    maxNumberOfMetrics: number;
}

export interface ChartAnalysisMetricDropdownFieldConfig {
    usePreviousValue: boolean;
}

export class ChartAnalysisMetricDropdownFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    placeholder: string;
    options: DropdownOptionModel[];
    multiMetricSettings: MultiMetricSettings;
    headingId: string;
    config?: ChartAnalysisMetricDropdownFieldConfig;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        options: DropdownOptionModel[],
        placeholder?: string,
        multiMetricSettings?: MultiMetricSettings,
        headingId?: string,
        config?: ChartAnalysisMetricDropdownFieldConfig
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.placeholder = placeholder;
        this.options = options?.map(opt => {
            if (opt.value === ChartMetricsEnum.audienceReach) {
                opt.value = ChartMetricsEnum.IMPRESSIONS;
            }
            return opt;
        });
        this.multiMetricSettings = multiMetricSettings;
        this.headingId = headingId;
        this.config = config;
    }
}
